import React from 'react';

export const IconFileGeneric: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <path
            d="M3 2C3 1.44772 3.44772 1 4 1H10L13 4V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2Z"
            stroke="currentColor"
            strokeWidth="1.25"
        />
        <path d="M10 1V4H13" stroke="currentColor" strokeWidth="1.25" />
    </svg>
);
